import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Category from "./Category";
import { Link } from "react-router-dom";

const Categories = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Categories" />
          <div>
            <div className="d-flex justify-content-end mb-3">
              <Link to="/categories/new" className="btn btn-primary">
                Add Category
              </Link>
            </div>
          </div>

          <div className="">
            <Category />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Categories;
